import axios from 'axios'
import { API_DEFAULT_TIMEOUT_MS } from '@/utils/constants'
import { applicationAuthorization } from '@/api/authorization'

const fetchServerTimestamp = async () => {
  let client = axios.create({
    baseURL: process.env.BASE_API,
    timeout: API_DEFAULT_TIMEOUT_MS,
    headers: {
      'Content-Type': 'application/json; charset=UTF-8',
      'Authorization': applicationAuthorization(process.env.APPLICATION_KEY)
    }
  })
  try {
    let response = await client.get('/v1/timestamp')
    return response.data.timestamp
  } catch (error) {
    throw new Error(error.response.data.message)
  }
}

export {
  fetchServerTimestamp
}



// WEBPACK FOOTER //
// ./src/api/timestamp.js